import { Taxonomy } from '../../../types';
import { TaxonomyGroup } from './taxonomy-list-filter.types';

export const groupTaxonomies = (taxonomies: Taxonomy[]): [TaxonomyGroup[], string[]] => {
    const groupDict: {
        [key: string]: Taxonomy[]
    } = {};

    taxonomies.forEach(taxonomy => {
        const letter = taxonomy.name[0];

        if (!groupDict[letter]) {
            groupDict[letter] = [];
        }

        groupDict[letter].push(taxonomy);
    });

    const letters = Object.keys(groupDict);

    return [
        letters.map(letter => ({
            letter,
            taxonomies: groupDict[letter].sort((a, b) => (
                a.name.localeCompare(b.name, undefined, { sensitivity: 'base'})
            ))
        })),
        letters
    ];
};

export const filterTaxonomies = (
    taxonomies: Taxonomy[],
    searchText: string
): Taxonomy[] => {
    const searchTextReady = searchText.trim().toLowerCase();

    return ( searchTextReady.length === 0
        ? taxonomies
        : taxonomies.filter(
            taxonomyData => taxonomyData.name
                .toLowerCase().includes(searchTextReady)
        )
    );
};
